<template>
    <div id="app" :class="type==0?'plat':'webdefault'" @click="setClock">
        <router-view></router-view>
        <loginmask ref="login"></loginmask>
    </div>
</template>

<script>
  import loginmask from './components/loginmask';
  import {StorageUtil} from './common/Auth';
  import {store} from './store/store';
  import {directive as onClickaway} from 'vue-clickaway';
  export default {
    name: 'app',
    data() {
      return {
        type: store.webType
      }
    },
      directives: {
          onClickaway: onClickaway,
      },
      beforeMount(){
        store.index=this;
        store.token = !StorageUtil.getString("token")? '' : StorageUtil.getString("token");
        store.user = !StorageUtil.getObject("user")? '' : StorageUtil.getObject("user");
        // if(store.opacType === 1){
        //    this.isTimeOut();
        // }
      },
    components: {
      loginmask
    },
      methods:{
          setClock(){
          //     if(store.opacType === 1){
          //         this.startTimer();
          //     }
          },
          // /**
          //  * 设置OPAC端，3分钟无操作，跳转到屏保页面**/
          //
          // startTimer() {
          //     clearInterval(store.timeOut);
          //     store.timeOut = setInterval(()=> {
          //         this.$router.push({path: '/screenSaver',query:{hallCode:  store.hallCode}});
          //         StorageUtil.removeObject('user');
          //         StorageUtil.removeObject('token');
          //     },6000*30);
          // },
          // isTimeOut() {
          //     if(this.$route.path === "/") {
          //         this.startTimer();
          //     }
          // },
      },
    watch: {
      $route() {
        //console.log('变化了')
      }
    },
  }
</script>

<style>
    *{
        -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
        -webkit-user-select:none; /*webkit浏览器*/
        -khtml-user-select:none; /*早期浏览器*/
        -moz-user-select:none;/*火狐*/
        -ms-user-select:none; /*IE10*/
        user-select:none;
    }
    body{
        margin: 0;
    }

    html {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        min-width: 1366px;
        height: 100%;
        overflow: auto;
    }

    body, #app {
        height: 100%;
    }

    .epubBody { /*epub电子书布局*/
        height: auto!important;
        background: #fdf7e3
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    *:not(.bd_weixin_popup), *:before, *:after {
        box-sizing: border-box;
        margin: 0;
    }

    a {
        text-decoration: none;
    }
    .epub-container {
        margin: 0 auto;
        z-index: 2;
    }
    /**全局变灰的样式，如果需要，将该class添加到这个最外层的div上即可**/
    .gray {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }
</style>
